module.exports = __webpack_public_path__ + "static/auf_hofen-e6ac9691b8f58a4231d6eb6dfebc5a1c.JPG";